/**
 * Persistent error box. Lives in the header; shows a single
 * message with no auto-dismiss (toasts are for transient feedback). Backed by an
 * atom so any module can call `showError`/`hideError` and the shell re-renders.
 */

import { Atom } from '../state/store.ts';

export const errorMessage = new Atom<string | null>(null);

export function showError(msg: string): void {
  errorMessage.set(msg);
}

export function hideError(): void {
  errorMessage.set(null);
}
